//
//
//
//
//
//
//
//
//
//
//
//
//

import { pageModule } from "@/api/index.js";
export default {
  data () {
    return {
      content: ""
    };
  },

  components: {},

  computed: {},

  created(){
    this.getPageData()
  },

  mounted(){},

  methods: {
    getPageData() {
      pageModule().then(res=>{
        let pageData = res.data;
        pageData.modulePageInfoList.map((item) => {
          item.content = JSON.parse(item.content);
          if (item.moduleType == 6) {
            this.content= item.content.text.replace('\n','</br>')
            // console.log(item.content.text,'this.content')
          }
        });
        console.log(pageData,'page')
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/view/index/inform.vue